<template>
  <AIController />
</template>

<script>
import AIController from '@/components-v2/presentation-editor/side-right/right-nav/AIController.vue'

export default {
  components: {
    AIController,
  },
}
</script>

<style lang="scss" scoped>
.ai-edit-panel {
  @apply h-full overflow-y-auto;
}
.ai-right-panel-container__content {
  @apply flex flex-col h-full;
  padding: 55px 1rem 0;
}
</style>
